import "../msa/MSAPageContainer.scss";

import { SECTION } from "constants/SettingsConstants";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { setService, setValidation } from "reducers/future-medical";
import { setCurrentSection, setValidationState } from "reducers/main";
import { useGetAmendedReviewValidationsByIdQuery } from "services/ar-screening-api";
import type {
  AmendedReviewScreeningType,
  ValidationDataType,
} from "types/DataTypes";
import { useDispatch } from "utils/redux";

type AmendedReviewPageContainerPropTypes = {
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  layout: "full" | "split";
  service?: AmendedReviewScreeningType;
};

const AmendedReviewPageContainer = ({
  header,
  footer,
  children,
  layout = "full",
  service,
}: AmendedReviewPageContainerPropTypes) => {
  const dispatch = useDispatch();
  const { reviewId } = useParams<{ reviewId?: string }>();

  const { data: validation } = useGetAmendedReviewValidationsByIdQuery(
    { reviewId },
    { skip: !reviewId },
  );

  useEffect(() => {
    dispatch(setService(service));
  }, [dispatch, service]);

  useEffect(() => {
    dispatch(setValidation(validation));
  }, [dispatch, validation]);

  useEffect(() => {
    dispatch(setCurrentSection(SECTION.AMENDED_REVIEW_SCREENING));
  }, [dispatch]);

  useEffect(() => {
    if (validation) {
      // extract and separate errors and warnings from the single `errors` array
      const extractedErrors: ValidationDataType[] = validation.errors.filter(
        (error: ValidationDataType) => error.level === "ERROR",
      );

      const extractedWarnings: ValidationDataType[] = validation.errors.filter(
        (warning: ValidationDataType) => warning.level === "WARN",
      );

      dispatch(
        setValidationState({
          errors: extractedErrors,
          warnings: extractedWarnings,
        }),
      );
    }
  }, [dispatch, validation]);

  return (
    <div className="swim-wrapper h-100">
      {header && <div className="MSAPageContainer__Header">{header}</div>}
      <div
        className={`grid-layout gl-2 no-gap-tb swimlanes msa-medical-${layout}`}
      >
        {children}
        {footer && <div className="MSAPageContainer__Footer">{footer}</div>}
      </div>
    </div>
  );
};

export default AmendedReviewPageContainer;
